/**
 * Visitor Analytics Hook
 * Automatically logs page visits to the backend
 */

// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('portal_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
    sessionStorage.setItem('portal_session_id', sessionId);
  }
  return sessionId;
};

// Log a page visit
export const logPageVisit = async (page) => {
  try {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    
    await fetch(`${API_URL}/api/analytics/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        page: page || window.location.pathname,
        referer: document.referrer || null,
        session_id: getSessionId()
      }),
      // Don't wait for response - fire and forget
      keepalive: true
    });
  } catch (error) {
    // Silently fail - don't interrupt user experience
    console.debug('Analytics log failed:', error);
  }
};

// Get public visitor counter
export const getVisitorCounter = async () => {
  try {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    const response = await fetch(`${API_URL}/api/analytics/counter`);
    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.debug('Counter fetch failed:', error);
  }
  return { today_visitors: 0, today_pageviews: 0, live_now: 0 };
};

export default { logPageVisit, getVisitorCounter };
